export const FOES_DB_KEY = 'foes-3.27'
